var map = {
	"./avalanche/footer/social/ic-discord.svg": "3f66",
	"./avalanche/footer/social/ic-etherscan.svg": "3ce0",
	"./avalanche/footer/social/ic-github.svg": "052b",
	"./avalanche/footer/social/ic-huobi.svg": "d3ef",
	"./avalanche/footer/social/ic-medium.svg": "14f0",
	"./avalanche/footer/social/ic-talk.svg": "b396",
	"./avalanche/footer/social/ic-telegram.svg": "66ce",
	"./avalanche/footer/social/ic-twitch.svg": "644b",
	"./avalanche/footer/social/ic-twitter.svg": "6041",
	"./avalanche/footer/social/ic-wchat.svg": "d89d",
	"./avalanche/footer/social/ic-www.svg": "624c",
	"./avalanche/footer/social/ic-youtube.svg": "7ce3",
	"./binance/footer/social/ic-discord.svg": "6d3d",
	"./binance/footer/social/ic-etherscan.svg": "ec4c",
	"./binance/footer/social/ic-github.svg": "cfa5",
	"./binance/footer/social/ic-huobi.svg": "c7f7",
	"./binance/footer/social/ic-medium.svg": "1af3",
	"./binance/footer/social/ic-telegram.svg": "a4e4",
	"./binance/footer/social/ic-twitch.svg": "db6f",
	"./binance/footer/social/ic-twitter.svg": "8045",
	"./binance/footer/social/ic-www.svg": "420e",
	"./binance/footer/social/ic-youtube.svg": "3f14",
	"./ethereum/footer/social/ic-discord.svg": "f377",
	"./ethereum/footer/social/ic-etherscan.svg": "acb6",
	"./ethereum/footer/social/ic-github.svg": "84bf",
	"./ethereum/footer/social/ic-huobi.svg": "1d0b",
	"./ethereum/footer/social/ic-medium.svg": "4abd",
	"./ethereum/footer/social/ic-talk.svg": "68f0",
	"./ethereum/footer/social/ic-telegram.svg": "2628",
	"./ethereum/footer/social/ic-twitch.svg": "2562",
	"./ethereum/footer/social/ic-twitter.svg": "0c2e",
	"./ethereum/footer/social/ic-wchat.svg": "8027",
	"./ethereum/footer/social/ic-www.svg": "af53",
	"./ethereum/footer/social/ic-youtube.svg": "7e88",
	"./huobi/footer/social/ic-discord.svg": "e604",
	"./huobi/footer/social/ic-etherscan.svg": "87f5",
	"./huobi/footer/social/ic-github.svg": "3707",
	"./huobi/footer/social/ic-huobi.svg": "f302",
	"./huobi/footer/social/ic-telegram.svg": "16bc",
	"./huobi/footer/social/ic-twitter.svg": "b193"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8582";